import LocalizedLink from './Localization/LocalizedLink'
import { CategoryButton, SliderNavButton, OldText, Track, useSlider } from '@gassan-ui'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { FC, useRef } from 'react'

type Props = {
  items: any[]
}

const NextPrevButton: FC<{ direction: 'next' | 'prev'; canMove: boolean; onClick(): void }> = ({
  direction,
  canMove,
  onClick,
}) => {
  return (
    <div
      className={cn(
        'absolute top-1/2 flex h-full -translate-y-1/2 items-center',
        'from-white from-50%',
        'w-16 sm:w-28',
        direction === 'prev' ? 'justify-start' : 'justify-end',
        direction === 'prev' ? 'left-0' : 'right-0',
        direction === 'prev' ? 'bg-gradient-to-r' : 'bg-gradient-to-l',
        canMove ? 'pointer-events-auto' : 'opacity-0',
      )}
    >
      <SliderNavButton onClick={onClick} direction={direction} />
    </div>
  )
}

const CategoryButtons: FC<Props> = ({ items }) => {
  const trackRef = useRef<HTMLDivElement>(null)
  const { onTouchEnd, prev, next, canMoveRight, canMoveLeft } = useSlider({
    trackRef,
    scrollAmount: 'full-width',
  })

  return (
    <div
      className={cn(
        'relative mx-auto max-w-[109rem] border-t border-shade-200 py-3',
        'sm:w-[calc(100%-2rem)] sm:py-6',
        'md:w-[calc(100%-3rem)]',
        'xl:w-[calc(100%-5.5rem)]',
      )}
    >
      <div className="pointer-events-none absolute inset-0">
        <NextPrevButton direction="prev" onClick={prev} canMove={canMoveLeft} />
        <NextPrevButton direction="next" onClick={next} canMove={canMoveRight} />
      </div>
      <div className=" px-4 sm:px-0">
        <Track ref={trackRef} onTouchEnd={onTouchEnd} className="gap-4">
          {items.map((item, index) => (
            <LocalizedLink href={`/${item.url_slug.value}`} key={index}>
              <CategoryButton
                image={
                  item.logo ? getKontentImage(item.logo.value[0]?.url, { width: 50 }) : undefined
                }
                href={`/${item.url_slug.value}`}
                className="snap-start"
              >
                <OldText mb="0">{item.title.value}</OldText>
              </CategoryButton>
            </LocalizedLink>
          ))}
        </Track>
      </div>
    </div>
  )
}

export default CategoryButtons
